module.exports = __webpack_public_path__ + "static/media/card-frames.747a3205.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card-frames.png
// module id = 791
// module chunks = 0